import { MenuItem } from '../menu';

export const connectMenuItem: MenuItem = {
  id: 'menu-item--resume',
  link: 'https://www.linkedin.com/in/albertksigman26/',
  displayName: 'connect',
  customClasses: ['hover-purp'],
  items: [
    {
      id: 'resume',
      link: '',
      displayName: 'Useful Links',
      customClasses: [],
      items: [
        {
          id: 'resume',
          link: '/resume',
          displayName: 'My Resume',
          customClasses: [],
          items: [],
        },
        {
          id: 'connect-on-linkedin',
          link: 'https://www.linkedin.com/in/albertksigman26/',
          displayName: 'Connect on LinkedIn',
          customClasses: [],
          items: [],
        },
        {
          id: 'contact',
          link: 'mailto:alsigman@gmail.com',
          displayName: 'Email Me',
          customClasses: [],
          items: [],
        },
        {
          id: 'chat-realtime',
          link: '',
          displayName: 'Chat Me Realtime (Coming Soon)',
          customClasses: [],
          items: [],
          info: 'Coming Soon! ** I am working on hooking up my Twilio API to this site so you can chat me real-time!',
        },
      ],
    },
  ],
};
